/**
 * Модуль для централизованного логирования
 */

/**
 * Уровни логирования
 */
export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3
}

/**
 * Класс для централизованного логирования
 */
export class Logger {
  static globalEnabled: boolean = false;
  private prefix: string;
  private level: LogLevel;
  private isEnabled: boolean;

  /**
   * Конструктор класса логгера
   * @param prefix Префикс для сообщений логгера
   * @param level Минимальный уровень логирования
   * @param isEnabled Включен ли логгер
   */
  constructor(prefix: string, level: LogLevel = LogLevel.INFO, isEnabled: boolean = true) {
    this.prefix = prefix;
    this.level = level;
    this.isEnabled = isEnabled;
  }

  /**
   * Логирование отладочных сообщений
   * @param message Сообщение
   * @param data Дополнительные данные
   */
  debug(message: string, ...data: any[]): void {
    if (Logger.globalEnabled && this.isEnabled && this.level <= LogLevel.DEBUG) {

    }
  }

  /**
   * Логирование информационных сообщений
   * @param message Сообщение
   * @param data Дополнительные данные
   */
  info(message: string, ...data: any[]): void {
    if (Logger.globalEnabled && this.isEnabled && this.level <= LogLevel.INFO) {

    }
  }

  /**
   * Логирование предупреждений
   * @param message Сообщение
   * @param data Дополнительные данные
   */
  warn(message: string, ...data: any[]): void {
    if (Logger.globalEnabled && this.isEnabled && this.level <= LogLevel.WARN) {
      console.warn(`[${this.prefix}] WARN:`, message, ...data);
    }
  }

  /**
   * Логирование ошибок
   * @param message Сообщение
   * @param data Дополнительные данные
   */
  error(message: string, ...data: any[]): void {
    if (Logger.globalEnabled && this.isEnabled && this.level <= LogLevel.ERROR) {
      console.error(`[${this.prefix}] ERROR:`, message, ...data);
    }
  }

  /**
   * Временно отключает логгер
   */
  disable(): void {
    this.isEnabled = false;
  }

  /**
   * Включает логгер
   */
  enable(): void {
    this.isEnabled = true;
  }

  /**
   * Изменяет уровень логирования
   * @param level Новый уровень логирования
   */
  setLevel(level: LogLevel): void {
    this.level = level;
  }
}

/**
 * Создает новый экземпляр логгера
 * @param prefix Префикс для сообщений логгера
 * @param level Уровень логирования
 * @returns Экземпляр логгера
 */
export function createLogger(prefix: string, level: LogLevel = LogLevel.INFO): Logger {
  return new Logger(prefix, level, true);
}


export const appLogger = createLogger('Catalog', LogLevel.INFO); 